export const FLAG_GETTING_CONTRACTORS = 'FLAG_GETTING_CONTRACTORS';
export const GET_CONTRACTORS = 'GET_CONTRACTORS';
export const CLEAR_CONTRACTORS = 'CLEAR_CONTRACTORS';
export const FLAG_CONTRACTOR_ACTIVITY = 'FLAG_CONTRACTOR_ACTIVITY';
export const GET_CONTRACTOR = 'GET_CONTRACTOR';
export const CLEAR_CONTRACTOR = 'CLEAR_CONTRACTOR';
